(function(){
  function updateStickyPrice() {
    var sealPrice = document.querySelector('.seal-subscriptions-widget .selected-price, .seal-price, [class*="seal"] .price, .seal-subscriptions-form .price');
    var stickyPrice = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__price');
    if (sealPrice && stickyPrice) {
      stickyPrice.textContent = sealPrice.textContent.trim();
    }
  }

  var observer = new MutationObserver(updateStickyPrice);
  var widget = document.querySelector('.seal-subscriptions-widget, [class*="seal-sub"], form[action*="cart"]');
  if (widget) observer.observe(widget, { subtree: true, childList: true, characterData: true });

  updateStickyPrice();
})();